import React, {Component} from 'react';
import PropTypes, {func} from 'prop-types';
import {connect} from 'react-redux';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import Calendar, {momentLocalizer} from 'react-big-calendar';
import moment from 'moment';
import DateTimeField from 'components/InputField/DateTimeField';
import Select from 'react-select';
import UserTypeSelectCalendar from 'containers/Calendar/UserTypeSelectCalendar';
import InputField from 'components/InputField/InputField';
import {FormControl, FormControlLabel} from 'material-ui/Form';
import Radio, {RadioGroup} from 'material-ui/Radio';
import {Link} from 'react-router';
import Icon from 'material-ui/Icon';
import FileField from 'components/InputField/FileField';


const labels = {
  webinar_title: 'Webinar Title',
  user: '',
  first_name: '',
  user_id: '',
  accreditation: '',
  sponsor: '',
  partnership: 'Partnership',
  start_date: '2021-07-12 11:02:21',
  end_date: '2021-07-12 12:02:21',
  name: 'Name',
  location: 'Location',
  expert_type: 'Expert type',
  user_types: 'User type',
  email: 'Mail',
  phone: 'Phone',
  contact_name: 'Your Contact Name',
  comment: ''
}

const accelerationMap = {
  'yes': 0,
  'no': 1,
  'not_applicable': 2,
  '0': 0,
  '1': 1,
  '2': 2
}

const localizer = momentLocalizer(moment);

function Event({event}) {
  return (
    <span className={event.booking_type}>
      <div>{moment(event.start_date).format('h:mm a')} - {moment(event.end_date).format('h:mm a')}</div>
      <div>{event.title}</div>
    </span>
  )
}

function EditCalendarSponsorForm({
                                   booking = {},
                                   errors = {},
                                   is_admin,
                                   is_sponsor,
                                   onDateChange,
                                   onUserTypeChangeCalendar,
                                   onFieldChange,
                                   onBookingExpertsAttributesChange,
                                   onAddExpert,
                                   onRemoveElement,
                                   onAccreditationChange,
                                   onSubmit,
                                   onTextAreaChange,
                                   onTermsOfServiceChange,
                                   termsOfService
                                 }) {
  return (
    <main className="site--width clearfix-c">
      <div className='edit'>
        <div className='page-content-calendar'>
          <div className='block-calendar'>
          </div>
          <div className='block-data-choice'>
            <div className='block-select-time'>
              <div className='title'> SELECT TIME</div>
              <DateTimeField
                className='col s12'
                onChange={onDateChange}
                value={booking.start_date}
                label="Start date"
                field_name='start_date'
                errors={errors['start_date']}
              />
              <DateTimeField
                className='col s12'
                onChange={onDateChange}
                value={booking.end_date}
                label="End date"
                field_name='end_date'
                errors={errors['end_date']}
              />
              <div className="user-choice">
                <UserTypeSelectCalendar
                  className='col s12'
                  onChange={onUserTypeChangeCalendar}
                  value={booking.user_types}
                  errors={errors.user_types}
                />
              </div>
              <h6> Enter your booking details</h6>
              <div className="add-webinar-booking">

                <InputField
                  className='coll s12'
                  label={labels['webinar_title']}
                  field_name='webinar_title'
                  onChange={onFieldChange}
                  errors={errors['webinar_title']}
                  autoComplete='new-password'
                  value={booking['webinar_title']}
                />
                {!is_sponsor &&
                <div>
                  <InputField
                    className='coll s12'
                    label={labels['contact_name']}
                    field_name='contact_name'
                    onChange={onFieldChange}
                    errors={errors['contact_name']}
                    autoComplete='new-password'
                    value={booking['contact_name']}
                  />
                  <InputField
                    className='coll s12'
                    label={labels['email']}
                    field_name='email'
                    onChange={onFieldChange}
                    errors={errors['email']}
                    autoComplete='new-password'
                    value={booking['email']}
                  />
                  <InputField
                    className='coll s12'
                    label={labels['phone']}
                    field_name='phone'
                    onChange={onFieldChange}
                    errors={errors['phone']}
                    autoComplete='new-password'
                    value={booking['phone']}
                  />
                </div>
                }
                <div className='form-details-booking'>
                  <h6> Speakers:</h6>
                  {(booking.booking_experts_attributes || booking.booking_experts).map((expert, index) => (
                    <div className="add_expert_row" key={index}>
                      <h6>Speaker {index + 1}</h6>
                      <Icon onClick={() => onRemoveElement(index)} className="remove_expert">close</Icon>
                      <InputField
                        className='coll s12'
                        label={labels['name']}
                        field_name='name'
                        onChange={(e) => (onBookingExpertsAttributesChange(e, index))}
                        errors={errors['name']}
                        autoComplete='new-password'
                        value={expert['name']}
                      />
                      <InputField
                        className='coll s12'
                        label={labels['expert_type']}
                        field_name='expert_type'
                        onChange={(e) => (onBookingExpertsAttributesChange(e, index))}
                        errors={errors['expert_type']}
                        autoComplete='new-password'
                        value={expert['expert_type']}
                      />
                      <InputField
                        className='coll s12'
                        label={labels['location']}
                        field_name='location'
                        onChange={(e) => (onBookingExpertsAttributesChange(e, index))}
                        errors={errors['location']}
                        autoComplete='new-location'
                        value={expert['location']}
                      />
                    </div>
                  ))}
                  <a className="add_option" onClick={onAddExpert} href="javascript:void(0)">
                    Add another speaker
                  </a>
                  <div className="texteria_feedback">
                    <textarea
                      placeholder="If you have any comments, suggestions or preferred speakers, please enter them here."
                      onChange={onTextAreaChange}
                      autoComplete='new-location'
                      value={booking.comment}
                    >
                    </textarea>
                  </div>

                </div>
                <div className='block-accreditation'>
                  <FormControl className='wimin-webinar'>
                    Apply for CPD accreditation?
                    <RadioGroup
                      aria-label="booking "
                      label="Accreditation"
                      onChange={onAccreditationChange}
                      value={accelerationMap[booking.accreditation]}
                      row
                    >
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary"/>}
                        label="Yes"
                      />
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary"/>}
                        label="No"
                      />
                      <FormControlLabel
                        value={2}
                        control={<Radio color="primary"/>}
                        label="Not applicable"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
              <button onClick={onSubmit} className="button_classic" type="button" name="button">EDIT</button>
            </div>
          </div>
        </div>
      </div>

    </main>

  )
}

EditCalendarSponsorForm.defaultProps = {};

EditCalendarSponsorForm.propTypes = {
  onFieldChange: func,
  onSubmit: func

};


export default EditCalendarSponsorForm;



// WEBPACK FOOTER //
// ./src/components/Calendar/EditCalendarForm.jsx